(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trade-application"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('trade-application-new');
  if (!form) return;
  var endpoint = form.getAttribute('data-endpoint');
  var button = form.querySelector('button[type="submit"]');
  var errorEl = form.querySelector('.ta__error');
  var busy = false;

  function val(name) {
    var el = form.elements[name];
    return el ? String(el.value || '').trim() : '';
  }

  function showError(kind) {
    errorEl.textContent = errorEl.getAttribute(kind === 'check' ? 'data-check' : 'data-generic');
    errorEl.hidden = false;
  }

  function finish(status, email) {
    var panel = document.getElementById(form.getAttribute(status === 'approved' ? 'data-approved' : 'data-pending'));
    if (status === 'approved' && email) {
      // Show the address the code goes to, and carry it into Shopify's sign-in page.
      var shown = panel.querySelector('[data-ta-email]');
      if (shown) shown.textContent = email;
      var signin = panel.querySelector('.ta__signin');
      if (signin) {
        signin.href = signin.getAttribute('data-login')
          + '?return_to=' + encodeURIComponent(signin.getAttribute('data-return'))
          + '&login_hint=' + encodeURIComponent(email);
      }
    }
    form.hidden = true;
    panel.hidden = false;
    panel.focus();
    panel.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    if (form.reportValidity && !form.reportValidity()) return;
    busy = true;
    errorEl.hidden = true;
    button.disabled = true;
    button.textContent = button.getAttribute('data-sending');

    var type = form.querySelector('input[name="type"]:checked');
    var payload = {
      type: type ? type.value : '',
      name: val('name'),
      business: val('business'),
      email: val('email'),
      phone: val('phone'),
      address: val('address'),
      vat: val('vat'),
      about: val('about'),
      marketing: !!(form.elements.marketing && form.elements.marketing.checked),
      hp: val('website')
    };

    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 20000) : null;

    // text/plain keeps this a simple CORS request (no preflight).
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(payload),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (res.ok && data && data.ok) return finish(data.status, payload.email);
        showError(res.status === 422 ? 'check' : 'generic');
      });
    }).catch(function () {
      showError('generic');
    }).then(function () {
      if (timer) clearTimeout(timer);
      busy = false;
      button.disabled = false;
      button.textContent = button.getAttribute('data-label');
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
